import { type Ripple } from "@dashboard/ripples/types";

// 2026-10-01 KST: 모델 메타데이터 힌트 문구 한글화
export const rippleModelMetadata: Ripple = {
  type: "improvement",
  ID: "model-metadata-header",
  TTL_seconds: 60 * 60 * 24 * 7,
  dateAdded: new Date(2026, 5, 12),
  content: {
    oneLiner: "모델 메타데이터를 상단 버튼에서 수정합니다",
    contextual: "이제 이 버튼을 누르면 열리는 전용 창에서 모델 메타데이터를 수정합니다.",
    global:
      "모델 메타데이터가 모델 페이지 하단에서 상단 버튼으로 옮겨졌습니다. 버튼을 누르면 전용 창이 열리며, 다른 항목을 지나 스크롤하지 않아도 공개·비공개 메타데이터를 쉽게 찾아 수정할 수 있습니다.",
  },
};
